import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import SandwichMenuPage from './pages/SandwichMenuPage';
import DeliMenuPage from './pages/DeliMenuPage';
import CateringPage from './pages/CateringPage';
import AboutPage from './pages/AboutPage';
import MiniGamesPage from './pages/MiniGamesPage';
import AdminPage from './pages/AdminPage';
import { PriceOverridesProvider } from './context/PriceOverridesContext';
console.log('DEBUG: src/App.css imported in src/App.js');

function App() {
  return (
    <PriceOverridesProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/menu" element={<SandwichMenuPage />} />
              <Route path="/deli" element={<DeliMenuPage />} />
              <Route path="/catering" element={<CateringPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/games" element={<MiniGamesPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </PriceOverridesProvider>
  );
}

export default App;
